import { P2GText } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { useTranslation } from 'react-i18next';
import { ContentBlock } from '~/components/core/content-block/content-block';
import { TranslationNamespaces } from '~/lib/constants';
import { toDisplayCurrency } from '~/lib/prices';
import { Currency } from '~/lib/types/basket-types';

interface Props {
  extendedBaseCoverAvailable: number;
  maximumCover: number;
  currency: Currency;
}

export const ParcelContentsProtected = ({ extendedBaseCoverAvailable, maximumCover, currency }: Props): JSX.Element => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  const { settings } = useTenant();

  return (
    <>
      <ContentBlock
        title={t('PARCEL_PROTECTION_INCLUDED_SUBTITLE', { defaultValue: 'Is parcel protection included?' })}
      >
        <P2GText variant="body1">
          {t('PARCEL_PROCTECTION_INCLUDED_INFO', {
            defaultValue:
              'This service is with {{cover}} parcel protection therefore if your parcel is lost or damaged you will be refunded the cost of carrriage and the cost of your items up to {{cover}}.',
            cover: toDisplayCurrency(currency, extendedBaseCoverAvailable, 0)
          })}
        </P2GText>
      </ContentBlock>
      <ContentBlock title={t('ADD_EXTRA_PROTECTION_SUBTITLE', { defaultValue: 'Can I add extra parcel protection?' })}>
        <P2GText variant="body1">
          {t('MAXIMUM_PARCEL_PROTECTION_INFO', {
            defaultValue:
              'Yes, {{tenant}} offer additional parcel protection on all delivery services. With this service you can protect your parcel up to the value of {{maximumCover}}. You can add extra protection to your order during the booking process.',
            maximumCover: toDisplayCurrency(currency, maximumCover, 0),
            tenant: settings['UI-SERVERLESS.PUBLIC.NAME']
          })}
        </P2GText>
      </ContentBlock>
    </>
  );
};
